import { render, staticRenderFns } from "./AnswerQuestion.vue?vue&type=template&id=17304ce7&scoped=true"
import script from "./AnswerQuestion.vue?vue&type=script&lang=js"
export * from "./AnswerQuestion.vue?vue&type=script&lang=js"
import style0 from "./AnswerQuestion.vue?vue&type=style&index=0&id=17304ce7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17304ce7",
  null
  
)

export default component.exports